import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './i18n';

import Header from './components/Header';
import Footer from './components/Footer';
import Login from './components/Login';
import AdminPanel from './pages/AdminPanel';
import Home from './pages/Home';
import AddCar from './pages/AddCar';
import SearchCar from './pages/SearchCar';
import CarDetails from './pages/CarDetails';
import Advertise from './pages/Advertise';
import ScrollToTop from './components/ScrollToTop';
import { StatsProvider } from './contexts/StatsContext';
import config from './config';

function App() {
  const [user, setUser] = useState(null);
  const adminPath = config.ADMIN_PANEL_PATH;

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <StatsProvider>
      <Router>
        <div className="App">
          {user ? (
            <AdminPanel user={user} onLogout={handleLogout} />
          ) : (
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/add" element={<AddCar />} />
                  <Route path="/search" element={<SearchCar />} />
                  <Route path="/reklama" element={<Advertise />} />
                  <Route path="/car/:plate/:id" element={<CarDetails />} />
                  <Route path="/car/:id" element={<CarDetails />} />
                  <Route path={adminPath} element={<Login onLogin={handleLogin} />} />
                  {/* Old predictable URLs — no login page */}
                  <Route path="/admin" element={<Navigate to="/" replace />} />
                  <Route path="/login" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
              <Footer />
            </>
          )}
          <ScrollToTop />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </Router>
    </StatsProvider>
  );
}

export default App;
